export default "__VITE_ASSET__BMuK1rsb__"